<label class="switcher--label"
       [ngClass]="switcherClasses"
       data-ideals="toggleViewAsListMode">
  <input class="switcher--input"
         type="checkbox"
         [checked]="value"
         (change)="onChange($event)" />
</label>
